export default {
  addRequest(state, pars) {
    state.requests.push(pars);
  },
  setRequests(state, pars) {
    state.requests = pars;
  }
};